export default "Écoles & groupes scolaires — Collectivités | Solution Éco France";
